import { extractFieldFromTextBuilder, createRegexSOLITT } from '../genericHelpers';
import { HandlerResult, PasteToQueryBaseHelper } from './pasteToQueryBaseHelper';

const extractField = extractFieldFromTextBuilder();
const extractFieldSOLITT = extractFieldFromTextBuilder(createRegexSOLITT);

interface NonAbapQueryData {
  xtmProjectName: string;
  repository: string;
  collection: string;
  fileName: string;
  sourceContact: string;
  languagesTranslatorTeams?: string;
  /*  stringId is not available and need to be entered by the translator manually */
  // stringId: string
}

export class PasteToNonAbapQueryHelper extends PasteToQueryBaseHelper<NonAbapQueryData> {
  constructor() {
    super([
      PasteToNonAbapQueryHelper.getFromSOLITTHandler,
      PasteToNonAbapQueryHelper.getFromNonAbapHandler
    ]);
  }

  private static getFromSOLITTHandler(
    text: string,
    { data }: HandlerResult<NonAbapQueryData>
  ): HandlerResult<NonAbapQueryData> {
    data.xtmProjectName = extractFieldSOLITT('Translation Area', text);
    data.repository = extractFieldSOLITT('Description', text);
    data.collection = extractFieldSOLITT('Collection Name', text);
    data.fileName = extractFieldSOLITT('Object Name', text);
    data.sourceContact = extractFieldSOLITT('Contact Person', text);
    data.languagesTranslatorTeams = extractFieldSOLITT('Target Languages-Translator Teams', text);

    const done =
      !!data.xtmProjectName &&
      !!data.repository &&
      !!data.collection &&
      !!data.fileName &&
      !!data.sourceContact;

    return { data, done };
  }

  private static getFromNonAbapHandler(
    text: string,
    { data }: HandlerResult<NonAbapQueryData>
  ): HandlerResult<NonAbapQueryData> {
    data.xtmProjectName = extractField('XTM_Project_Name', text);
    data.repository = extractField('Repository', text);
    data.collection = extractField('Collection', text);
    data.fileName = extractField('Filename', text);
    data.sourceContact = extractField('Contact Person', text);
    data.languagesTranslatorTeams = extractField('Target Languages-Translator Teams', text);

    const done =
      !!data.xtmProjectName &&
      !!data.repository &&
      !!data.collection &&
      !!data.fileName &&
      !!data.sourceContact;

    return { data, done };
  }
}
